import React, { FC } from "react";
import { Modal } from "../../../components/common";
import { NewBankAccountForm } from "../../forms/wallets";

type Props = {
  isOpen: boolean;
  close: () => void;
  callback: (data?: any) => void;
  showExtraText?: boolean;
};

export const NewBankAccountModal: FC<Props> = ({
  isOpen,
  close,
  callback,
  showExtraText = false,
}) => {
  return (
    <>
      <Modal
        isOpen={isOpen}
        close={close}
        title="Add bank account"
        subtitle={
          <>
            Add your{" "}
            <strong className="font-manrope font-extrabold">
              Saving or NRO
            </strong>{" "}
            bank account to get payment in your local currency
            {showExtraText && (
              <>
                <br />
                <br />
                <strong>Step 3 of 3</strong>
              </>
            )}
          </>
        }
      >
        <NewBankAccountForm callback={callback} />
      </Modal>
    </>
  );
};
